/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Options_TitleInputs */



/**
* | output |
* | --- |
* | "Properties to compare" |
*
* @param {Compare_Event_Groups_Options_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_options_title = /** @type {((inputs?: Compare_Event_Groups_Options_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Options_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propriétés à comparer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu vergleichende Eigenschaften")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietà da confrontare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Свойства для сравнения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propiedades para comparar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("待比较的属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("比較する特性")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तुलना करने योग्य गुण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Propriedades a comparar")
	return /** @type {LocalizedString} */ ("Properties to compare")
});